<template>
  <div class="add-dietitian">
    <img class="bg" src="" alt="" />
    <img
      class="qrcode"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/324fe0f11e0542536bc707407692e9e7.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.add-dietitian {
  position: relative;
  .bg {
    width: 100%;
    height: auto;
  }
  .qrcode {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
    width: 100px;
    height: 100px;
  }
}
</style>
